// extracted by mini-css-extract-plugin
module.exports = {"contactUsContainer":"SgErrorPage_contactUsContainer__jPUit","icon":"SgErrorPage_icon__aHch1","assistanceText":"SgErrorPage_assistanceText__-wRKN"};